var _defs, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReinforcement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.014,
    height: 100.014,
    viewBox: "0 0 1055 1055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #282c31;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-width: 1px;\n      }\n\n      .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: #ef4c38;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4",
    "data-name": "Ret\\xE2ngulo 4",
    className: "cls-1",
    x: -92,
    y: -87,
    width: 1239,
    height: 1279
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4-2",
    "data-name": "Ret\\xE2ngulo 4",
    className: "cls-2",
    x: 85,
    y: 86,
    width: 884,
    height: 883
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_3",
    "data-name": "Ret\\xE2ngulo 3",
    className: "cls-3",
    d: "M87.344,881.257V872.91H1002v8.347H87.344Zm0-38.982H1002v8.44H87.344v-8.44Zm0-30.51H1002v8.284H87.344v-8.284Zm0.625-40.919V762.5H1001.53v8.347H87.969Zm-0.625-38.919H1002v8.346H87.344v-8.346Zm0-30.635H1002v8.44H87.344v-8.44Zm0-30.51H1002v8.284H87.344v-8.284ZM69,575.1H983.656v8.346H69V575.1Zm0-30.635H983.656v8.409H69V544.46Zm0-30.541H983.656v8.315H69v-8.315Zm0-76.588H983.656v8.409H69v-8.409Zm0-30.541H983.656v8.315H69V406.79Zm0-30.635H983.656v8.378H69v-8.378Zm0.625-30.541H983.656V353.9H69.625v-8.284ZM69,278.717H983.656v8.441H69v-8.441Zm0.625-30.541H983.656v8.347H69.625v-8.347Zm0-30.635H983.656v8.44H69.625v-8.44Zm0-30.541H983.656v8.346H69.625V187ZM983.188,614.014H69.625v-8.347H983.188v8.347ZM87.969,903.483H1001.53v8.346H87.969v-8.346ZM989,957H74v-8H989v8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_3-2",
    "data-name": "Ret\\xE2ngulo 3",
    className: "cls-4",
    d: "M968.656,916.563v19.156H926.625V970H906.812V935.719H143.75V970H123.844V935.719H85.438V916.563h38.406v-111.5H85.438V785.937h38.406V652.75H85.438V633.594h38.406V488.781H85.438V469.625h38.406V336.469H85.438V317.344h38.406V184.188h-39V86H968.656v98.188H926.625V317.344h42.031v19.125H926.625V469.625h42.031v19.156H926.625V633.594h42.031V652.75H926.625V785.937h42.031v19.125H926.625v111.5h42.031ZM906.812,184.188H143.75V317.344H906.812V184.188Zm0,152.281H143.75V469.625H906.812V336.469Zm0,152.312H143.75V633.594H906.812V488.781Zm0,163.969H143.75V785.937H906.812V652.75ZM143.75,805.062v111.5H906.812v-111.5H143.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinforcement);
export default __webpack_public_path__ + "static/media/reinforcement.4d34d94dc0d61fc3b5ab088b62fc3ee5.svg";
export { ForwardRef as ReactComponent };